export default "__VITE_ASSET__49556098__"